/**
 * Mamba 🐍
 * Creating access to affordable therapy.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import axios, { AxiosRequestConfig, Method } from 'axios';

import { axios as axiosClient, MambaApiError } from '../axios.config';

import { ClaimReferralRewardResponse } from '../models/ClaimReferralRewardResponse';
import { CreateProviderReferralRequest } from '../models/CreateProviderReferralRequest';
import { GetProviderReferralsForAtlasResponse } from '../models/GetProviderReferralsForAtlasResponse';
import { GetProviderReferralsResponse } from '../models/GetProviderReferralsResponse';
import { GetReferralCampaignResponse } from '../models/GetReferralCampaignResponse';
import { HTTPValidationError } from '../models/HTTPValidationError';
import { ProviderReferralForAtlasReadDetail } from '../models/ProviderReferralForAtlasReadDetail';
import { ProviderReferralRead } from '../models/ProviderReferralRead';
import { RecipientType } from '../models/RecipientType';
import { SubmitProviderReferralLeadRequest } from '../models/SubmitProviderReferralLeadRequest';

/* tslint:disable:no-unused-variable member-ordering max-line-length */
/* eslint-disable no-useless-concat */

export class ProviderReferralApiResource {
  /**
     * Claim Referral Reward
     * 
     * @param userId 
     * @param salesforceReferralId 
     * @param recipientType 
     
     */
  public claimReferralReward(
    userId: number,
    salesforceReferralId: string,
    query?: { recipient_type: RecipientType },
    axiosConfig?: AxiosRequestConfig
  ): Promise<ClaimReferralRewardResponse> {
    const apiRoute =
      '/user/{user_id}/claim-referral-reward/{salesforce_referral_id}';
    const reqPath = apiRoute
      .replace('{' + 'user_id}', String(userId))
      .replace('{' + 'salesforce_referral_id}', String(salesforceReferralId));
    const reqConfig = {
      ...axiosConfig,
      method: 'POST' as Method,
      url: reqPath,
      params: query,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Create Provider Referral
     * 
     * @param userId 
     * @param createProviderReferralRequest 
     
     */
  public createProviderReferral(
    userId: number,
    body: CreateProviderReferralRequest,
    axiosConfig?: AxiosRequestConfig
  ): Promise<ProviderReferralRead> {
    const apiRoute = '/user/{user_id}/provider-referrals';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'POST' as Method,
      url: reqPath,
      data: body,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Diff Task For Sf Vs Native Referrals
     * 
     * @param userId 
     
     */
  public diffTaskForSfVsNativeReferrals(
    userId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<any> {
    const apiRoute = '/user/{user_id}/diff-referrals';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Provider Referral For Atlas
     * 
     * @param userId 
     * @param providerReferralSalesforceId 
     
     */
  public getProviderReferralForAtlas(
    userId: number,
    providerReferralSalesforceId: string,
    axiosConfig?: AxiosRequestConfig
  ): Promise<ProviderReferralForAtlasReadDetail> {
    const apiRoute =
      '/internal/user/{user_id}/provider-referrals/{provider_referral_salesforce_id}';
    const reqPath = apiRoute
      .replace('{' + 'user_id}', String(userId))
      .replace(
        '{' + 'provider_referral_salesforce_id}',
        String(providerReferralSalesforceId)
      );
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Provider Referral For Candidate
     * 
     * @param userId 
     
     */
  public getProviderReferralForCandidate(
    userId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<ProviderReferralRead> {
    const apiRoute = '/user/{user_id}/provider-referrals/candidate';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Provider Referrals
     * 
     * @param userId 
     * @param nextPageUrl 
     
     */
  public getProviderReferrals(
    userId: number,
    query?: { next_page_url?: string },
    axiosConfig?: AxiosRequestConfig
  ): Promise<GetProviderReferralsResponse> {
    const apiRoute = '/user/{user_id}/provider-referrals';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
      params: query,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Provider Referrals For Atlas
     * 
     * @param userId 
     * @param nextPageUrl 
     
     */
  public getProviderReferralsForAtlas(
    userId: number,
    query?: { next_page_url?: string },
    axiosConfig?: AxiosRequestConfig
  ): Promise<GetProviderReferralsForAtlasResponse> {
    const apiRoute = '/internal/user/{user_id}/provider-referrals';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
      params: query,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Get Referral Campaign
     * 
     * @param userId 
     
     */
  public getReferralCampaign(
    userId: number,
    axiosConfig?: AxiosRequestConfig
  ): Promise<GetReferralCampaignResponse> {
    const apiRoute = '/user/{user_id}/referral-campaign';
    const reqPath = apiRoute.replace('{' + 'user_id}', String(userId));
    const reqConfig = {
      ...axiosConfig,
      method: 'GET' as Method,
      url: reqPath,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }

  /**
     * Submit Provider Referral Lead
     * 
     * @param submitProviderReferralLeadRequest 
     
     */
  public submitProviderReferralLead(
    body: SubmitProviderReferralLeadRequest,
    axiosConfig?: AxiosRequestConfig
  ): Promise<object> {
    const apiRoute = '/provider-referrals';
    const reqPath = apiRoute;
    const reqConfig = {
      ...axiosConfig,
      method: 'POST' as Method,
      url: reqPath,
      data: body,
    };

    return axiosClient
      .request(reqConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          throw new MambaApiError({ apiRoute, error });
        }
        throw error;
      });
  }
}

export const ProviderReferralApi = new ProviderReferralApiResource();
